import React from "react";
import {
    BaseComponentProps,
    createComponentBase,
} from "../../../libs/components";

import { Tooltip } from "../tooltip";
import { Icon } from "../icon";

export interface FileUploadProps extends BaseComponentProps {
    onUpload: (files: File[]) => void;
    value?: File[];
    placeholder?: string;
    isError?: boolean;
    error?: string;
}

export const MultipleFileUpload = ({
    onUpload,
    value,
    placeholder,
    isError,
    error,
    className,
}: FileUploadProps) => {
    const componentClassName = "a-multipleFileUpload";
    const { Container } = createComponentBase(componentClassName, "div");

    const [selectedFiles, setSelectedFiles] = React.useState<File[]>([]);

    React.useEffect(() => {
        if (value) {
            setSelectedFiles(value);
        }
    }, [value]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const filesArray = Array.from(event.target.files);
            setSelectedFiles([...selectedFiles, ...filesArray]);
            onUpload([...selectedFiles, ...filesArray]);

            event.target.value = '';
        }
    };

    const modifiers = {
        [`${!placeholder && "placeholder"}`]: !!placeholder,
        'isUploaded': selectedFiles.length > 0,
        'error': isError,
    };

    const removeHandler = (index: number) => {
        const files = [...selectedFiles];
        files.splice(index, 1);
        setSelectedFiles(files);
        onUpload(files);
    };

    return (
        <Container className={className} modifiers={modifiers}>
            <Tooltip message={error} isVisible={isError}>
                <div className={`${componentClassName}__container`} tabIndex={1}>
                    <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        className={`${componentClassName}__input`}
                    />

                    <span className={`${componentClassName}__placeholder`}>{selectedFiles.length > 0 ? `${selectedFiles.length} files selected` : placeholder}</span>
                    <button className={`${componentClassName}__button`}>Browse File</button>
                </div>
            </Tooltip>
            {selectedFiles.length > 0 &&
                <div className={`${componentClassName}__files`}>
                    {selectedFiles.map((file, index) => (
                        <div key={index} className={`${componentClassName}__files__file`}>
                            <span key={index} className={`${componentClassName}__files__name`}>{file.name}</span>
                            <button key={index} className={`${componentClassName}__files__remove`} type="button" onClick={() => removeHandler(index)}>
                                <Icon icon="cancel" size="primary" />
                            </button>
                        </div>
                    ))}
                </div>
            }
        </Container>
    );
};
